import { IFormField } from '..';

/**
 * Maps array of dynamic form inputs into subarrays, while .
 * NOTE: Given the functionality of FormFields and its implementation in the LeadGenForm,
 * IT WILL BREAK the UI if the firstName or lastName fields aren't at an even index in the list of form items.
 * */
export const chunkFormInput = (array: IFormField[], defaultSize: number): Array<any> => {
  if (!array || array.length === 0) return [];

  const firstInput = array[0];

  // Dynamically decide the chunk size
  let size = defaultSize;
  if (firstInput.width === 'third') size = 3;
  else if (firstInput.width === 'full') size = 1;
  else size = 2;

  const chunk = array.slice(0, size);

  // Separate full-width fields from others
  const halfOrThird = chunk.filter(input => input.width === 'half' || input.width === 'third' || typeof input.width === 'undefined');
  const full = chunk.filter(input => input.width === 'full');

  const firstChunk = [halfOrThird, ...full].filter(item => !Array.isArray(item) || item.length > 0);

  if (!firstChunk.length) return array;

  return firstChunk.concat(chunkFormInput(array.slice(size), defaultSize));
};
